/**
 * Single source of truth for brand + contact details.
 * CommonJS on purpose: webpack imports it AND scripts/generate-seo.js
 * requires it at build time, so the site, the meta tags and the sitemap
 * can never drift apart.
 */
const SITE_URL = 'https://www.codelithiclabs.com';

module.exports = {
  url: SITE_URL,
  name: 'Codelithic Labs Inc.',
  shortName: 'Codelithic Labs',
  legalName: 'Codelithic Labs Inc.',
  tagline: 'Technology that moves your business forward',
  description:
    'Calgary-based technology partner building custom software, web and mobile apps, cloud and security solutions for clients worldwide.',
  email: 'info@codelithiclabs.com',
  address: {
    street: '106 Aquila Drive',
    locality: 'Calgary',
    region: 'AB',
    country: 'CA',
    countryName: 'Canada',
  },
  get addressLine() {
    return `${this.address.street}, ${this.address.locality}, ${this.address.region}, ${this.address.countryName}`;
  },
  founded: '2024',
  // HQ is Calgary; delivery is remote and worldwide. Used in copy and schema
  // so the two never drift apart.
  hq: 'Calgary, Alberta',
  serviceArea: 'worldwide',
  social: {
    facebook: 'https://www.facebook.com/people/Codelithic-Labs-Inc/61571775761064/',
    linkedin: 'https://ca.linkedin.com/company/codelithic-labs-inc',
    instagram: 'https://www.instagram.com/codelithiclabs/',
  },
  stats: [
    { value: 40, suffix: '+', label: 'Projects delivered' },
    { value: 12, suffix: '', label: 'Industries served' },
    { value: 98, suffix: '%', label: 'Client retention' },
    { value: 24, suffix: '/7', label: 'Support coverage' },
  ],
  values: [
    {
      title: 'Innovation',
      desc: 'We keep looking for better ways to solve the problem in front of us, not just familiar ones.',
    },
    {
      title: 'Integrity',
      desc: 'Straight answers on scope, cost and timelines, including when the news is inconvenient.',
    },
    {
      title: 'Collaboration',
      desc: 'We work as an extension of your team, in your tools, on your cadence.',
    },
    {
      title: 'Customer Focus',
      desc: 'Every decision traces back to whether it makes your business measurably better.',
    },
  ],
  process: [
    {
      step: '01',
      title: 'Discover',
      desc: 'We map the problem, the constraints and the people it affects before writing a line of code.',
    },
    {
      step: '02',
      title: 'Design',
      desc: 'Architecture, interface and data model, reviewed with you while changes are still cheap.',
    },
    {
      step: '03',
      title: 'Build',
      desc: 'Short iterations with working software at the end of each one, deployed where you can use it.',
    },
    {
      step: '04',
      title: 'Launch & evolve',
      desc: 'We ship, measure against the goals we set in discovery, and keep improving from there.',
    },
  ],
};
